<template>
	<AsiChip :small="small" :x-small="xSmall" label @click.stop="copy">
		<span class="mr-2 font-weight-bold">{{ $t('customerItem.numberShort') }}</span>
		{{ customerItem.customerItemNumber }}
	</AsiChip>
</template>

<script lang="ts">
	import {Vue, Component, Prop} from 'vue-property-decorator';
	import AsiChip from "@/components/common/AsiChip.vue";
	import ClipboardHelper from "@/helpers/ClipboardHelper";
	import {ICustomerItemShopListEntry} from "@/models/customer-item/CustomerItemShopModels";

	@Component({
		components: {AsiChip}
	})
	export default class ItemChipCustomerItemNumber extends Vue {

		@Prop({type: Object, required: true})
		public customerItem!: ICustomerItemShopListEntry;

		@Prop({type: Boolean, default: false})
		public small!: boolean;

		@Prop({type: Boolean, default: false})
		public xSmall!: boolean;

		private copy(): void {
			ClipboardHelper.copyText(this.customerItem.customerItemNumber);
		}

	}
</script>

<style scoped lang="scss">

</style>
